import { eventTrackExtra } from "@/apis/gameJump";
import { getInvoiceBootstrap } from "@/apis/invoiceCenter";

let invoiceTrackingContext = {};

const isAndroid = () => {
  const userAgent = navigator.userAgent || "";
  return userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
};

const getOs = () => isAndroid() ? "android" : "ios";

const readContext = () => invoiceTrackingContext;

export const setInvoiceTrackingContext = (session, bootstrap) => {
  const context = {
    session,
    appkey: bootstrap && bootstrap.appkey,
    user_id: bootstrap && bootstrap.user_id,
  };
  invoiceTrackingContext = context;
};

export const ensureInvoiceTrackingContext = async session => {
  const context = readContext();
  if (context.session === session && context.appkey && context.user_id) return context;
  const bootstrap = await getInvoiceBootstrap(session);
  setInvoiceTrackingContext(session, bootstrap);
  return bootstrap;
};

export const clearInvoiceTrackingContext = () => {
  invoiceTrackingContext = {};
};

export const getInvoiceType = invoiceType => {
  const value = String(invoiceType || "").toLowerCase();
  return Number(invoiceType) === 2 || value === "company" || value.indexOf("公司") >= 0 ? "company" : "personal";
};

export const trackInvoiceEvent = (event, extraData = {}) => {
  const context = readContext();
  const os = getOs();
  if (!context.appkey || !context.user_id) return Promise.resolve();
  return eventTrackExtra({
    appkey: context.appkey,
    event,
    device_id: "null",
    device_name: "null",
    system_version: "null",
    user_id: context.user_id,
    os,
    extra_data: JSON.stringify(extraData),
    client_extra_data: JSON.stringify({ os, jh_channel: "null" }),
  }).catch(error => {
    // eslint-disable-next-line no-console
    console.error("invoice event tracking failed", {
      event,
      code: error && error.code,
      message: error && error.message,
    });
  });
};
